import { useContext } from 'react'
import { NotificationContext } from './Notification.context'

const useNotification = () => {
    return useContext(NotificationContext)
}

export default useNotification
